function Cool(){
    return(
        <div className="flexColumn">
            <h1>A good snack</h1>
            <img src="https://nutritionfacts.org/app/uploads/2019/01/5884349332_95d70f789d_o.jpg" alt="olives"/>
        </div>
    )
}

export default Cool;